import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import {
    ServiceRequestHeader,
    SRCrumbs,
    SRSearchPanel,
    SRFab,
} from "./sr-components";
import { ServiceRequestsList } from "./service-requests-list";
import { SideOverlay } from "../../components";
import { SrRequestView } from "./sr-requests-view/sr-request-view";
import { SrAgentChatPanel, SrAgentFab } from "./sr-agent-chat";
import { useStore } from "../../helpers";
import { useTranslation } from "react-i18next";
import { useLocalStorage } from "react-use";
import { useLocation, useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";

const ServiceRequestHome = observer(() => {
    const rootStore = useStore();
    const { serviceRequestsStore } = useStore();

    const queryClient = useQueryClient();
    const { showServiceRequest, showSrAgentChat } = serviceRequestsStore;
    const { t } = useTranslation("service_request_home");
    const location = useLocation();
    const navigate = useNavigate();
    const params = new URLSearchParams(location.search);
    const modeQuery = params.get("mode");

    const [showMyRequests, setShowMyRequests] = useLocalStorage(
        "sr-show-my-requests",
        false
    );

    const [viewMode, setViewMode] = useLocalStorage<"card" | "table">(
        "sr-view-mode",
        "card"
    );

    const [faceSelectedRequest, setFaceSelectedRequest] = useState<any[] | null>(
        null
    );

    useEffect(() => {
        if (modeQuery === "my") {
            setShowMyRequests(true);
        } else {
            setShowMyRequests(false);
        }
    }, [modeQuery]);

    // const close_modal = () => {
    //     serviceRequestsStore.setshowServiceRequest(false);
    // };
    const close_modal = () => {
        serviceRequestsStore.setshowServiceRequest(false);

        serviceRequestsStore.setActiveServiceRequest(null);

        serviceRequestsStore.setSubjectId(-1);

        localStorage.removeItem("sr-subject");
        localStorage.removeItem("sr-subject-saved");

        // rootStore.userStore.setAttachmentImage(null);

        queryClient.removeQueries(["sr-details"]);
    };

    return (
        <div className="min-h-screen">
            {/* Sticky Breadcrumbs */}
            <SRCrumbs />

            {/* Main Content Container */}
            <div className="px-4 md:px-6 lg:px-8 py-4">
                {/* Header with View Toggle */}
                <ServiceRequestHeader
                    showMyRequests={showMyRequests}
                    onToggleMyRequests={(value) => {
                        setShowMyRequests(value);
                        serviceRequestsStore.setPageNumber(1);
                    }}
                    viewMode={viewMode}
                    onViewChange={setViewMode}
                />

                <SRSearchPanel
                    onSelectFaceRequest={(requests) =>
                        setFaceSelectedRequest(requests)
                    }
                />

                <ServiceRequestsList
                    mode={showMyRequests ? "MY_REQUESTS" : "ALL_REQUESTS"}
                    viewMode={viewMode}
                    faceSelectedRequest={faceSelectedRequest}
                    onClearFaceFilter={() => setFaceSelectedRequest(null)}
                />

                <SRFab onClick={() => navigate("newrequest")} />
                <SrAgentFab
                    onClick={() => serviceRequestsStore.setShowSrAgentChat(true)}
                />

                <SideOverlay
                    children={<SrRequestView />}
                    onClose={close_modal}
                    show={showServiceRequest}
                    title={t("sr_title")}
                    size="large"
                />

                <SideOverlay
                    children={<SrAgentChatPanel />}
                    onClose={() =>
                        serviceRequestsStore.setShowSrAgentChat(false)
                    }
                    show={showSrAgentChat}
                    title="SR Assistant"
                    size="large"
                    flush
                />
            </div>
        </div>
    );
});

export default ServiceRequestHome;
